<template>
  <div class="site-header">
    <div class="container">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            <img class="site-logo" src="../assets/logo.png" alt="BMI Pricing Calculator" />
          </router-link>
        </div>
        <div class="navbar-start" v-if="profile.user.email">
          <router-link v-if="profile.response.admin" class="navbar-item" to="/settings">
            {{$t("translation.linkSettings")}}
          </router-link>
          <router-link v-if="profile.response.user" class="navbar-item" to="/discounts">
            {{$t("translation.linkDiscount")}}
          </router-link>
        </div>
        <div class="navbar-end" v-if="profile.user.email">
          <div class="navbar-item is-paddingless">
            <span class="user">{{profile.user.email}}</span>
            <a :href="profile.response.logoutURL" class="button is-info is-outlined is-small">
              {{$t("translation.linkLogout")}}
            </a>
          </div>
          <div class="navbar-item">
            <languageSelector selectStyle="is-small" />
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import userStore from '@/store/userStore';
import languageSelector from '@/components/languageSelector.vue';

export default {
  components: {
    languageSelector,
  },

  data() {
    return {
      profile: userStore,
    };
  },

  i18n: {
    messages: {
      en: {
        translation: {
          linkSettings: 'Settings',
          linkDiscount: 'View Company Discount',
          linkLogout: 'Logout',
        },
      },
      nor: {
        translation: {
          linkSettings: 'Innstillinger',
          linkDiscount: 'Bruker rabatt liste',
          linkLogout: 'Logg ut',
        },
      },
    },
  },
};
</script>

<style lang="scss">
.site-header {
  background: #fff;
}

.site-logo {
  padding-right: 10px;
}

.user {
  padding-right: 10px;
}
</style>
